<div class="actionable-table-card-container">
	<div class="actionable-table-card-container__start">
		<div class="actionable-table-card-container__start__header title white" data-title="{{ date.title }}:&nbsp;{{ date.value | date: 'd MMM yyyy' }}">
			{{ date.value | date: 'd MMM yyyy' }}
		</div>
	</div>
	<div class="actionable-table-card-container__end">
		<div class="actionable-table-card-container__end__event-type mr-1 title2" data-title="{{ eventType.title }}:&nbsp;{{ eventType.value }}">{{ eventType.value }}</div>
		<div class="actionable-table-card-container__end__extra-details">
			<div
				class="actionable-table-card-container__end__extra-details__item mr-1"
				*ngFor="let additionalItem of additionalItems"
				data-title="{{ additionalItem.title }}:&nbsp;{{ additionalItem.value }}"
			>
				{{ additionalItem.value }}
			</div>
			<div
				class="actionable-table-card-container__end__extra-details__description"
				data-title="{{ description.title }}:&nbsp;{{ description.value == '' ? 'No description' : description.value }}"
			>
				{{ description.value == '' ? 'No description' : description.value }}
			</div>
			<div
				class="actionable-table-card-container__end__extra-details__description-elps"
				data-title="{{ description.title }}:&nbsp;{{ description.value == '' ? 'No description' : description.value }}"
			>
				...
			</div>
			<!-- <div class="actions" *ngFor="let action of actions">TODO
        <div class="action__icon" [inlineSVG]="iconEnum[(action?.type)]" (click)="handleEvent(action.callback)"></div>
      </div> -->
		</div>
	</div>
</div>
